import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { getTranslation } from '../utils/translation';

const toastIds = {};

const setToastId = (toastKey, toastId) => {
    toastIds[toastKey] = toastId;
};

function showToast({ toastKey, title, className }) {
    if (!toastIds[toastKey]) {
        const toastId = toast.warn(
            <div>
                <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '10px' }} />
                <span>{title}</span>
            </div>,
            {
                position: 'bottom-left',
                hideProgressBar: true,
                closeButton: false,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                className,
            },
        );

        setToastId(toastKey, toastId);
    }
}

function dismissToast(toastKey) {
    if (toastIds[toastKey]) {
        toast.dismiss(toastIds[toastKey]);
        setToastId(toastKey, null);
    }
}

export function useProducerStatusToast({ className, isLive }) {
    const { betLines } = useSelector(state => state.betSlip);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);

    useEffect(() => {
        const hasPreMatchBetLine = betLines.some(b => !b.isLive);
        const hasLiveBetLine = betLines.some(b => b.isLive);

        if (producerStatuses.isPreMatchDown && (hasPreMatchBetLine || isLive === false)) {
            showToast({
                toastKey: 'preMatchToastId',
                title: getTranslation('preMatchProducerIsDown'),
                className,
            });
        } else {
            dismissToast('preMatchToastId');
        }

        if (producerStatuses.isLiveDown && (hasLiveBetLine || isLive === true)) {
            showToast({
                toastKey: 'liveToastId',
                title: getTranslation('liveProducerIsDown'),
                className,
            });
        } else {
            dismissToast('liveToastId');
        }
    }, [producerStatuses, betLines, isLive, className]);

    useEffect(() => {
        return () => {
            dismissToast('preMatchToastId');
            dismissToast('liveToastId');
        };
    }, []);
}
